import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import { Card, CardBody, Col, Button, ButtonToolbar, Modal } from "reactstrap";
import EyeIcon from "mdi-react/EyeIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import renderCheckBoxField from "../../../../shared/components/form/CheckBox";
import axios from "axios";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import GoogleLogin from 'react-google-login';
import { jwtDecode } from "jwt-decode";
import { GOOGLE_CLIENT_TOKEN } from '../../../Common/api';
import { addAnalytics } from '../../../Common/analytics';



const url = window.location.hostname;
const google = window.google;
// const url='15.206.34.41';
var port = window.location.port;
var portData = window.location.port;
var locationData = [];
var token;
var new_password = '';
var confirm_password = ''
var userName = ''

class LogInForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.onLocation = this.onLocation.bind(this);
    this.state = {
      username: "",
      password: "",
      new_password: "",
      confirm_password: "",
      showPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      showUserNameMsg: false,
      showPassMsg: false,
      showLocationUI: false,
      locationNotSelected: false,
      showLoginUi: true,
      selectedLocations: "",
      location_list: [],
      locationModal: false,
      Failedmodal: false,
      failed_message: [],
      success_message: '',
      Successmodal: false,
      userName: '',
      loading: false
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }
  showNewPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showNewPassword: !prevState.showNewPassword }));
  }
  showConfirmPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showConfirmPassword: !prevState.showConfirmPassword }));
  }

  Failedtoggle = () => {
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }
  Successtoggle = () => {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }


  componentWillMount() {
    if (port == 8091) {
      port = "8090";
    } else if (port == 8098) {
      port = "8099";
    } else {
      port = "8088";
    }
    userName = this.getCookie("userName")
    this.setState(
      {
        userName: userName

      })
    // alert(userName);
  }

  locationToggle = () => {
    this.setState((prevState) => ({ locationModal: !prevState.locationModal }));
  }

  handleChange = (e) => {
    this.setState({
      username: e.target.value,
    });
  };

  handleChange1 = (e) => {
    this.setState({
      password: e.target.value,
    });
  };
  handleChange2 = (e) => {
    this.setState({
      new_password: e.target.value,
    });
    new_password = e.target.value
  };
  handleChange3 = (e) => {
    // this.setState({
    //   confirm_password: e.target.value,
    // });
    confirm_password = e.target.value
  };

  changeLocation = (e) => {
    this.setState({
      locationNotSelected: false,
      selectedLocations: e.target.value,
    });
  };

  createCookie = (cookieName, cookieValue, daysToExpire) => {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  };

  deleteCookie = (name) => {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  };
  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }


  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }
  onLocation() {
    if (this.state.selectedLocations === "" || this.state.selectedLocations === undefined || this.state.selectedLocations === null) {
      this.setState({
        locationNotSelected: true
      });

      return false;
    }

    const payload = {
      location: this.state.selectedLocations,
    };
    // this.deleteCookie();

    API.post('/auth/users/location/activate', { param: payload })
      .then((response) => {
        addAnalytics('Login', 'Location Selection', this.state.selectedLocations);
        token = this.accessCookie("token") + ":" + this.state.selectedLocations;
        this.createCookie("token", token);
        this.createCookie("selectedLocation", this.state.selectedLocations);
        this.createCookie("direct_putaway_flag", response.data.direct_putaway);
        this.createCookie("receiving_app_flag", response.data.receiving_app);
        this.createCookie("picking_app_flag", response.data.picking_app);
        this.createCookie("is_mrsl", response.data.is_mrsl);
        this.createCookie("emp_role", response.data.emp_role);
        this.createCookie("virtual_bins", response.data.virtual_bins);
        this.createCookie("userMenu", response.data.userMenu);

        window.location.href = window.location.protocol + "//" + url + ":" + portData + "/dashboard_default";
      }).catch(function (error) { });
  }

  _handleKeyDown(e) {
    if (e.key === "Enter") {
      this.onLogin();
    }
  }

  _handleKeyDown1(e) {
    if (e.key === "Enter") {
      this.onLocation();
    }
  }



  validateGoogleLogin = async (googleResponse) => {
    try {
      this.setState({ showLoading: true });

      //console.log("credential",googleResponse.credential)

      const payload = {
        tokenId: googleResponse.credential,
        email: googleResponse.decoded.email,
      };

      API.post('/auth/oauth2/googlelogin', { param: payload })
        .then((response) => {

          console.log(response);

          if (response.data.success == false) {
            this.setState({
              Failedmodal: true,
              failed_message: response.data.message
            })

          } else {
            if (response.data.empRoles[0] == "mis") {

              this.deleteCookie("selectedLocation");
              token = response.data.token;
              this.createCookie("token", token);
              this.createCookie("userName", response.data.userName);
              this.createCookie("userLocations", "");
              this.createCookie("userMenu", response.data.userMenu);
              this.createCookie("invOwner", response.data.invOwner);

              window.location.href = "http://" + url + ":" + portData + "/dashboard_mis";

            } else {
              this.deleteCookie("selectedLocation");
              token = response.data.token;
              this.createCookie("token", token);
              this.createCookie("userName", response.data.userName);
              this.createCookie("userLocations", response.data.userLocations);
              //this.createCookie("userMenu", response.data.userMenu);
              this.createCookie("invOwner", response.data.invOwner);

              locationData = response.data.userLocations.split("$$##!");
              this.locationToggle();
              this.setState({

                location_list: locationData,
              });

            }
          }
        })
        .catch(function (error) { });
    } catch (err) {
      this.setState({ showLoading: false });
      this.toast.error("Your email ID is not registered with Jarvis. Please reach out to Techops team for new ID creation.");
    }
  };

  onGoogleLoginSuccess = (response) => {
    //console.log("RES", response);
    try {
      localStorage.setItem('GoogleTokenId', response.credential);
      const decoded = jwtDecode(response.credential);
      localStorage.setItem('GoogleMailId', decoded.email);
      localStorage.setItem('GoogleName', decoded.name);
      console.log(decoded.email, decoded.name)
      if (decoded.email.endsWith('@lynk.co.in')) {
        //console.log("validate");
        this.validateGoogleLogin({ ...response, decoded });
      }
    } catch (err) {
      this.onGoogleLoginFailure(err);
    }
  };

  onGoogleLoginFailure = (error) => {
    console.log(error)
    addAnalytics("Login", "Google Login Failed", JSON.stringify(error))
    //setAnalytics('no username', window.location.pathname);
    this.toast.error("Google Login Failed. Try again later")
  };

  responseGoogle = (response) => {
    // Handle Google authentication response
    console.log(response);
    if (response.error) {
      // Handle login failure
      console.error('Google authentication failed:', response.error);
    } else {
      // Handle login success
      console.log('Google authentication successful:', response);
      // You can perform additional actions here, such as sending the token to your server for validation
    }
  };


  onLogin() {
    this.setState({
      loading: true
    })
    if (new_password != confirm_password) {
      this.setState({
        failed_message: ['Password did not match'],
        Failedmodal: true,
        loading: false
      });
    } else if (this.state.password === "") {
      this.setState({
        showPassMsg: true,
        loading: false
      });
    }
    else {
      addAnalytics('Login', 'Password Login')

      const payload = {
        user_name: userName,
        old_password: this.state.password,
        new_password: confirm_password,
      };

      API.post('/auth/reset-password/', { param: payload })
        .then((response) => {
          if (response.data.success == true) {
            this.setState({
              Successmodal: true,
              success_message: response.data.message,
              loading: false
            });
          } else {
            this.setState({
              Failedmodal: true,
              failed_message: response.data.password_errors[0],
              loading: false
            });
          }
        }).catch(function (error) {
          this.setState({
            Failedmodal: true,
            failed_message: error.response.data.password_errors,
            loading: false
          });
        }.bind(this));
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const { showPassword, showConfirmPassword, showNewPassword, locationModal, Failedmodal, Successmodal } = this.state;

    return (
      <div>
        <form style={{ margin: 'auto', marginTop: '7%', alignItems: 'center', flexDirection: 'column' }} className="form" onSubmit={handleSubmit}>
          {this.state.showLoginUi && (
            <div style={{ marginLeft: 10 }}>
              <div className="form__form-group">

              </div>
              <div className="form__form-group" style={{ marginTop: 25 }}>
                <div className="form__form-group-field" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                  <p style={{ margin: '0px 0px 8px 5px', alignSelf: 'flex-start', fontSize: '16px' }}>Old Password</p>

                  <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', width: '312px' }}>
                    <Field
                      name="password"
                      component="input"
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={this.state.password}
                      onChange={this.handleChange1}
                      onKeyDown={(e) => this._handleKeyDown(e)}
                      style={{
                        border: 'none',
                        outline: 'none',
                        height: '44px',
                        flex: 1,
                        paddingLeft: '10px',
                        fontSize: '14px',
                        width: 400
                      }}
                    />

                    <div
                      className="form__form-group-icon"
                      style={{ padding: '0 10px', cursor: 'pointer' }}
                      onClick={(e) => this.showPassword(e)}
                    >
                      <img
                        src={require("../../../../images/eye.svg")}
                        alt="Show Password"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                  </div>
                </div>

                {this.state.showPassMsg && (
                  <div>
                    <h5 style={{ color: "red", marginLeft: "5px" }}>
                      Incorrect Password!!
                    </h5>
                  </div>
                )}
              </div>
              <div className="form__form-group" style={{ marginTop: 25 }}>
                <div className="form__form-group-field" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                  <p style={{ margin: '0px 0px 8px 5px', alignSelf: 'flex-start', fontSize: '16px' }}>New Password</p>

                  <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', width: '312px' }}>
                    <Field
                      name="new_password"
                      component="input"
                      type={showNewPassword ? "text" : "password"}
                      placeholder="New Password"
                      value={this.state.new_password}
                      onChange={this.handleChange2}
                      onKeyDown={(e) => this._handleKeyDown(e)}
                      style={{
                        border: 'none',
                        outline: 'none',
                        height: '44px',
                        flex: 1,
                        paddingLeft: '10px',
                        fontSize: '14px',
                        width: 400
                      }}
                    />

                    <div
                      className="form__form-group-icon"
                      style={{ padding: '0 10px', cursor: 'pointer' }}
                      onClick={(e) => this.showNewPassword(e)}
                    >
                      <img
                        src={require("../../../../images/eye.svg")}
                        alt="Show Password"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                  </div>
                </div>

                {this.state.showPassMsg && (
                  <div>
                    <h5 style={{ color: "red", marginLeft: "5px" }}>
                      Incorrect Password!!
                    </h5>
                  </div>
                )}
              </div>
              <div className="form__form-group" style={{ marginTop: 25 }}>
                <div className="form__form-group-field" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                  <p style={{ margin: '0px 0px 8px 5px', alignSelf: 'flex-start', fontSize: '16px' }}>Confirm Password</p>

                  <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', width: '312px' }}>
                    <Field
                      name="confirm_password"
                      component="input"
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm Password"
                      value={this.state.confirm_password}
                      onChange={this.handleChange3}
                      onKeyDown={(e) => this._handleKeyDown(e)}
                      style={{
                        border: 'none',
                        outline: 'none',
                        height: '44px',
                        flex: 1,
                        paddingLeft: '10px',
                        fontSize: '14px',
                        width: 400
                      }}
                    />

                    <div
                      className="form__form-group-icon"
                      style={{ padding: '0 10px', cursor: 'pointer' }}
                      onClick={(e) => this.showConfirmPassword(e)}
                    >
                      <img
                        src={require("../../../../images/eye.svg")}
                        alt="Show Password"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                  </div>
                </div>

                {this.state.showPassMsg && (
                  <div>
                    <h5 style={{ color: "red", marginLeft: "5px" }}>
                      Incorrect Password!!
                    </h5>
                  </div>
                )}
              </div>
              <div style={{ marginTop: "35px" }}>
                <Button className="btn-lg button_enable" onClick={this.onLogin} disabled={this.state.loading}>
                  {this.state.loading &&
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  }
                  Reset
                </Button>
              </div>


            </div>


          )}
          {this.state.showLocationUI && (
            <div>
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <div className="form__form-group-icon">
                    <img
                      src={require("../../../../images/location.png")}
                      style={{ width: "20px", height: "20px" }}
                    ></img>
                  </div>
                  <div className="form__form-group-field">
                    <select
                      className="form-control select_style"
                      style={{ fontSize: 13, width: 290 }}
                      onChange={this.changeLocation}
                      onKeyDown={(e) => this._handleKeyDown1(e)}
                    >
                      <option value="">Select Location</option>
                      {this.state.location_list &&
                        this.state.location_list.length > 0 &&
                        this.state.location_list.map((location_list) => {
                          return (
                            <option value={location_list}>
                              {" "}
                              {location_list}
                            </option>
                          );
                        })}
                    </select>

                  </div>

                </div>
                {this.state.locationNotSelected &&
                  <span style={{ color: 'red', fontSize: 12 }}> Please select location </span>
                }
                <div
                  className="account__btns"
                  style={{ marginTop: 10, marginLeft: 120 }}
                >
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      marginLeft: "30px",
                      backgroundColor: "#333333",
                      color: "#fbbb00",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    onClick={this.onLocation}
                  >
                    Proceed
                  </Button>
                </div>
              </div>
            </div>
          )}
        </form>

        <Modal isOpen={locationModal} toggle={this.locationToggle}>
          <div className="modal__header">
            <button
              className="fa fa-times modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.locationToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <div>
              <img
                src={require("../../../../images/login_map.svg")}
                style={{ width: "40%" }}
              ></img>
            </div>

            <div className="form__form-group-field" style={{ marginTop: 20, flexDirection: 'column' }}>
              <div style={{ width: '78%', margin: 'auto', textAlign: 'left' }}>
                <label style={{ textAlign: 'left' }}> Choose a location </label>
              </div>
              <div>
                <select
                  className="form-control select_style"
                  style={{ fontSize: 13, width: 300, height: 40 }}
                  onChange={this.changeLocation}
                  onKeyDown={(e) => this._handleKeyDown1(e)}
                >
                  <option value="">Select Location</option>
                  {this.state.location_list &&
                    this.state.location_list.length > 0 &&
                    this.state.location_list.map((location_list) => {
                      return (
                        <option value={location_list}>
                          {" "}
                          {location_list}
                        </option>
                      );
                    })}
                </select>
              </div>

            </div>


          </div>
          <ButtonToolbar className="modal__footer">

            <Button
              className="btn-lg button_enable "

              onClick={this.onLocation}
            >
              Proceed
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Failedmodal} backdrop="static" toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Failedtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            {/* <h4>{this.state.failed_message} </h4> */}
            <h4 style={{textAlign : 'center',margin : '10px 20px 0px 20px'}}>
              {this.state.failed_message.map((line, index) => (
                <div key={index}>
                   {line.trim()}
                </div>
              ))}
            </h4>



          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal isOpen={Successmodal} backdrop="static" toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>{this.state.success_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              // onClick={this.Successtoggle}
              onClick={() => window.location.href = '/'}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>


      </div>
    );
  }
}

export default reduxForm({
  form: "log_in_form", // a unique identifier for this form
})(LogInForm);

